import React, { ReactNode, useCallback, useMemo } from 'react'

import { useGetStaticList } from '../../core/APIHooks/static'

export type StaticPagesListProps = {
  children?: ReactNode
  className?: string
  linkClassName?: string
  separatorClassName?: string
  onNavigateToSlug?: (slug: string) => void
}

const StaticPagesList = ({
  children,
  className,
  linkClassName,
  separatorClassName,
  onNavigateToSlug = () => {},
}: StaticPagesListProps) => {
  const { data: pages } = useGetStaticList()

  const onHandleClick = useCallback(
    (slug: string) => {
      if (onNavigateToSlug) {
        return () => onNavigateToSlug(slug)
      }
      return undefined
    },
    [onNavigateToSlug],
  )

  const ListRendered = useMemo(() => {
    if (pages) {
      return pages.map((page, index) => {
        return (
          <React.Fragment key={page.id}>
            {!!index && <span className={separatorClassName}> | </span>}
            <span className={linkClassName} onClick={onHandleClick(page.slug)}>
              {page.title}
            </span>
          </React.Fragment>
        )
      })
    }
    return null
  }, [linkClassName, onHandleClick, pages, separatorClassName])

  return (
    <div className={className}>
      {ListRendered}
      {children}
    </div>
  )
}

export default StaticPagesList
